module.exports = __webpack_public_path__ + "img/trend_white.7b9752b1.svg";